/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetMcpNetworkTraffic } from "../funcs/telemetryGetMcpNetworkTraffic.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetMcpNetworkTrafficResult } from "../models/components/getmcpnetworktrafficresult.js";
import {
  GetMcpNetworkTrafficRequest,
  GetMcpNetworkTrafficSecurity,
} from "../models/operations/getmcpnetworktraffic.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMcpNetworkTrafficQueryData = GetMcpNetworkTrafficResult;

export function prefetchGetMcpNetworkTraffic(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMcpNetworkTrafficRequest,
  security?: GetMcpNetworkTrafficSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMcpNetworkTrafficQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMcpNetworkTrafficQuery(
  client$: GramCore,
  request: GetMcpNetworkTrafficRequest,
  security?: GetMcpNetworkTrafficSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetMcpNetworkTrafficQueryData>;
} {
  return {
    queryKey: queryKeyGetMcpNetworkTraffic({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getMcpNetworkTrafficQueryFn(
      ctx,
    ): Promise<GetMcpNetworkTrafficQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetMcpNetworkTraffic(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMcpNetworkTraffic(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "telemetry", "getMcpNetworkTraffic", parameters];
}
